var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentNode)?_c('run-node',{key:_vm.currentNodeId,attrs:{"nodeId":_vm.currentNodeId,"node":_vm.currentNode,"showPrevious":!_vm.onFirstNode,"isLast":_vm.onLastNode},on:{"previous":_vm.gotoPrevious,"next":_vm.gotoNext}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }